<template>
    <section>
        <div class="page-wrap">
            <div class="container checkout">
                <div class="box-content">
                    <div class="row">
                        <div class="col-md-6 border-success-right">
							<h2>Checkout</h2>
                            <div>
                                <div class="th hidden-xs">
                                    <div class="row">
                                        <div class="col-sm-4">PRODUCT</div>
                                        <div class="col-xs-8">
                                            <div class="row">
                                                <div class="col-xs-7">DESCRIPTION</div>
                                                <div class="col-xs-2 text-center">QTY</div>
                                                <div class="col-xs-3 col-md-3 text-right">SUBTOTAL</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tb" v-for="(item, itemIndex) in cart">
                                    <div class="row">
                                        <div class="col-sm-4 cart-img">
                                            <div class="prod-container">
                                                <img v-if="item.gc" class="prod-img" src="images/giftcertificate.png"/>
                                                <img v-else class="prod-img" v-bind:src="getCartItemImage(item)"/>
                                                <div class="prod-replica">
                                                    <div class="prod-replica-table">
                                                        <div class="prod-replica-table-td checkout" v-bind:class="products[item.item_id].classes">
                                                            <p v-for="n in products[item.item_id].max_lines">{{ item.lines[n-1] }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-8">
                                            <!-- base product first -->
                                            <div class="row tr">
                                                <div class="col-xs-7" v-html="products[item.item_id].description"></div>
                                                <div class="col-xs-2 text-center">
                                                    <div class="wrap-count">
                                                        <div class="amount">
                                                            <span>1</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3 col-md-3 text-right price">
                                                    <span class="pull-left">$&nbsp;</span>{{ products[item.item_id].price }}
                                                </div>
                                            </div>
                                            <!-- list of dependent products -->
                                            <div class="row tr" v-for="(qty, childId) in item.children">
                                                <div class="col-xs-7"
                                                     v-html="childProducts[item.item_id].children[childId].description"
                                                ></div>
                                                <div class="col-xs-2 text-center">
                                                    <div class="wrap-count">
                                                        <div class="amount">
                                                            <span>{{ qty }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3 col-md-3 text-right price">
                                                    <span class="pull-left">$&nbsp;</span>
                                                    {{ calcLineItemTotal(item.item_id, childId, qty) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- Promo Code -->
								<promotional-code-form v-if="isPromoCodeAllowed"></promotional-code-form>
                                <div class="text-right">
                                    <div class="total">Subtotal
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ subTotal | currency({symbol: ''}) }}
                                        </span>
                                    </div>
									<!-- Promo Code -->
									<div class="total" v-if="isPromoCodeAllowed">Promotional Discount
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ promoDiscount.toFixed(2) }}
                                        </span>
                                    </div>
                                    <div class="total" v-if="isConvenienceFeeAllowed">Convenience&nbsp;Fee
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ convenienceFee | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <div class="total">Sales&nbsp;Tax
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ salesTax | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <strong class="subtotal">Order&nbsp;Total:
                                        <span>$&nbsp;</span>{{ orderTotal | currency({symbol: ''}) }}
                                    </strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 border-success">

							<h2 class="billing-info">Billing Information <span class="billing-asterisk">*</span></h2>
                            <form action="" class="info-form info-space">
                                <div class="row">
                                    <div class="col-sm-5" v-bind:class="{'has-error': errors.has('billing.first_name')}">
                                        <input type="text" class="form-control" placeholder="First Name"
                                            v-model="billing.first_name"
                                            data-vv-name="billing.first_name"
                                            v-validate="'required'"
                                        />
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text" class="form-control" placeholder="M.I."
                                            v-model="billing.middle_name"
                                        />
                                    </div>
                                    <div class="col-sm-5" v-bind:class="{'has-error': errors.has('billing.last_name')}">
                                        <input type="text" class="form-control" placeholder="Last Name"
                                            v-model="billing.last_name"
                                            data-vv-name="billing.last_name"
                                            v-validate="'required'"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <input type="text" class="form-control" placeholder="Company"
                                            v-model="billing.company"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12" v-bind:class="{'has-error': errors.has('billing.country')}">
                                        <country-selector class="form-control"
                                            v-on:country-change="onCountryChange"
                                            v-bind:countries="countries"
                                            v-bind:country="billing.country"
                                            v-on:change="onFedexFieldBlur('country')"
                                            v-bind:class="{'validated': fedex.isValidated}"
                                            data-vv-name="billing.country"
                                            data-vv-value-path="selectedCountry"
                                            v-validate="'required'"
                                        ></country-selector>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12" v-bind:class="{'has-error': errors.has('billing.address1')}">
                                        <input type="text" class="form-control" placeholder="Address 1"
                                            v-model="billing.address1"
                                            v-on:blur="onFedexFieldBlur('address1')"
                                            v-bind:class="{'validated': fedex.isValidated}"
                                            data-vv-name="billing.address1"
                                            v-validate="'required'"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <input type="text" class="form-control" placeholder="Address 2"
                                            v-model="billing.address2"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4" v-bind:class="{'has-error': errors.has('billing.city')}">
                                        <input type="text" class="form-control" placeholder="City"
                                            v-model="billing.city"
                                            v-on:blur="onFedexFieldBlur('city')"
                                            v-bind:class="{'validated': fedex.isValidated}"
                                            data-vv-name="billing.city"
                                            v-validate="'required'"
                                        />
                                    </div>
                                    <div class="col-sm-4">
                                        <state-province-selector class="form-control"
                                            v-on:state-change="onStateChange"
                                            v-bind:country="billing.country"
                                            v-bind:states="states"
                                            v-bind:state="billing.state_prov"
                                            v-on:change="onFedexFieldBlur('state_prov')"
                                            v-bind:class="{'validated': fedex.isValidated}"
                                        ></state-province-selector>
                                    </div>
                                    <div class="col-sm-4" v-bind:class="{'has-error': errors.has('billing.postal_code')}">
                                        <input type="text" class="form-control" placeholder="Zip Code"
                                            v-model="billing.postal_code"
                                            v-on:blur="onFedexFieldBlur('postal_code')"
                                            v-bind:class="{'validated': fedex.isValidated}"
                                            data-vv-name="billing.postal_code"
                                            data-vv-delay="100"
                                            v-validate="'required|min:5'"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4" v-bind:class="{'has-error': errors.has('billing.phone')}">
                                        <input type="text" class="form-control" placeholder="Phone Number"
                                            v-model="billing.phone"
                                            data-vv-name="billing.phone"
                                            v-validate="'required|phone'"
                                        />
                                    </div>
                                    <div class="col-sm-8" v-bind:class="{'has-error': errors.has('billing.email') }">
                                        <input type="text" class="form-control" placeholder="Email Address"
                                            v-model="billing.email"
                                            data-vv-name="billing.email"
                                            v-validate="'required|email'"
                                        />
                                    </div>
                                </div>
                                <div class="wrap text-danger" v-if="!fedex.isValidated && fedex.errorMessage.length > 0">
                                    <span>{{ fedex.errorMessage }}</span>
                                </div>
								
								
                            
                                <div class="wrap text-danger" v-if="errs.payment_cc.length > 0">
                                    <span>{{ errs.payment_cc }}</span>
                                </div>
                            </form>
                            <template v-if="hasShippableItems">
                                <h2>Shipping Information</h2>
                                <div class="shipping-info">
                                    <div>
                                        <div class="checkbox-item">
                                            <input type="radio" name="ship" id="ship2billing" class="check-style"
                                                :checked="shipTo == 'ship2billing'"
                                                v-on:click="shippingChanged($event)"
                                            />
                                            <label for="ship2billing">Ship all items to billing address</label>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="checkbox-item">
                                            <input type="radio" name="ship" id="ship2another" class="check-style"
                                                :checked="shipTo == 'ship2another'"
                                                v-on:click="shippingChanged($event)"
                                            />
                                            <label for="ship2another">Ship all items to another address</label>
                                        </div>
                                    </div>
                                    <div v-if="hasShippableItems > 1">
                                        <div class="checkbox-item">
                                            <input type="radio" name="ship" id="ship2multiple" class="check-style"
                                                :checked="shipTo == 'ship2multiple'"
                                                v-on:click="shippingChanged($event)"
                                            />
                                            <label for="ship2multiple">Ship items to multiple addresses</label>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <p class="outside-us">
                                <br/><span class="text-danger">*</span>
                                Please call us to place an order outside of the contiguous United States (International, Alaska or Hawaii).
                            </p>
							<div class="text-center">
                                <div class="checkbox-item">
                                    <input type="checkbox" class="check-style" id="accept_terms" name="accept_terms"
                                            v-model="accept"
                                            data-vv-name="accept"
                                            v-validate="'required'"
                                    />
                                    <label for="accept_terms" v-bind:class="{'has-error': errors.has('accept') }">Accept</label>&nbsp;
                                    <a class="text-success pointer" v-on:click="showTermsConditions()">Terms &amp; Conditions</a>
                                    </div>
                                </div>
								<div class="btn-wrap text-center">
									<a id="place-order" class="btn btn-danger btn-block"
									   v-on:click.stop.prevent="submitCustomerOrder()"
									   v-bind:disabled="isSubmitButtonDisabled"
									>CONTINUE TO PAYMENT</a> 
								</div>
                            </div>
                            <!--<div class="row">
                                <div class="col-md-12">
                                    <div class="btn-wrap text-center">
                                        <a id="place-order" class="btn btn-danger btn-block"
                                           v-on:click.stop.prevent="submitCustomerOrder()"
                                           v-bind:disabled="isSubmitButtonDisabled"
                                        >CONTINUE TO PAYMENT</a> 
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <address-popup
            modal-id="addAnotherAddressPopup"
            invoked-on="showAnotherAddressPopup"
            on-submit="submitAnotherAddressPopup"
            on-discard="closeAnotherAddressPopup"
            v-bind:countries="this.countries"
            v-bind:regions="this.states"
        ><slot>All items will be shipped to this address.</slot>
        </address-popup>

        <multiple-address-popup></multiple-address-popup>
        <!-- auxiliary custom implementation of AddressPopup -->
        <address-popup
            modal-id="addNewAddressPopup"
            invoked-on="showNewAddressPopup"
            on-submit="submitNewAddressPopup"
            on-discard="closeNewAddressPopup"
            v-bind:countries="this.countries"
            v-bind:regions="this.states"
        ><slot>Add a new shipping address.</slot>
        </address-popup>

        <creditcard-validator></creditcard-validator>
    </section>
</template>

<script type="text/jsx">
    import Vue from 'vue';
    import { Event } from '../../../../assets/js/components/frontend/event.vue'
    import { mapState, mapGetters } from 'vuex'
    import store from '../store'
    // mixins
    import CampaignConfigurationMixin from '../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import OrderCreationMixin from '@/components/mixin/order-creation.vue'
    import CreditcardValidator from '@/components/elements/creditcard-validator.vue'
    // elements
    import CountrySelector from './elements/country-selector.vue'
    import StateProvinceSelector from './elements/state-province-selector.vue'
	/* Promo Code */
    import PromotionalCodeForm from '@/components/elements/promotional-code-form.vue'

    import AddressPopup from '@/components/popup/address-popup.vue';
    import MultipleAddressPopup from '@/components/popup/multiple-address-popup.vue';
    import MlbOptIn from "./content/MlbOptIn";

    // tests
    // import { payment as testPayment } from '%/store/addressbook'
    // import { payment as testPayment } from '%/store/all2another'

    export default {
        name: 'checkout',
        mixins: [
            CampaignConfigurationMixin,
            OrderCreationMixin,
            require('./mixin/fedex-validation.vue')
        ],/* Promo Code */
        components: {
            'country-selector': CountrySelector,
            'state-province-selector': StateProvinceSelector,
            'address-popup': AddressPopup,
            'multiple-address-popup': MultipleAddressPopup,
            'creditcard-validator': CreditcardValidator,
            'promotional-code-form': PromotionalCodeForm,
            'mlb-opt-in': MlbOptIn
        },
        beforeRouteEnter(to, from, next) {
            if (store.getters.cartItemsCount > 0) {
                next();
            } else {
                next({name: 'Cart'});
            }
        },/* Promo Code */
        computed: {
            ...mapState([
                'campaign', 'promo', 'marketing'
            ]),/* Promo Code */
            ...mapGetters([
                'billing', 'countries', 'products', 'childProducts', 'cart',
				'hasShippableItems', 'shipItemTo',
                'subTotal', 'promoDiscount', 'salesTax'
            ]),
            ...mapGetters({ addresses: 'shippingAddresses'}),
            states: function () {
                return this.$store.state.regions[this.billing.country] || {}
            },
            shipTo: {
                get: function () {
                    return this.$store.getters.shipTo
                },
                set: function (newValue) {
                    console.log('attempt to set shipTo to new value:', newValue);
                }
            },
            isSubmitButtonDisabled: function () {
                return this.isPlacingOrder ?
                    true :
                    this.isAddressUnresolved || !this.accept
                ;
            },
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            }
        },
        created: function () {
            Event.$on('submitAnotherAddressPopup', this.onAnotherAdressSubmitted);
            Event.$on('addNewAddress', this.onNewAdressSubmitted);
            Event.$on('closeAnotherAddressPopup', function () {
                console.log('on closeAnotherAddressPopup');
            });
            Event.$on('handleCreditcardResult', this.onHandleCreditcardResult);
            this.$validator.extend('phone', {
                getMessage: field => 'The ' + field + ' value is not valid.',
                validate: value => {
                    var phone = value.trim().replace(/[\s-]/g, '');
                    return /^[0-9]{10}$/.test(phone);
                }
            });
        },
        beforeDestroy: function () {
            Event.$off('onAnotherAdressSubmitted', this.onAnotherAdressSubmitted);
            Event.$off('addNewAddress', this.onNewAdressSubmitted);
        },
        data: function () {
            return this.getDefaultData();
        },
        methods: {
            getDefaultData: function () {
                return {
                    fedex: {
                        event: 'validateAddress',
                        listener: 'handleFedexResult',
                        container: 'billing', // overridden
                        /**/ isValidated: false,
                        // isValidated: true, // DEBUG
                        errorMessage: ''
                    },
                    // payment: testPayment, // DEBUG
                    /**/
                    payment: {
                        amount: ''
                    },
                    /**/
                    accept: false,
                    isPlacingOrder: false,
                    errs: {
                        payment_cc: ''
                    }

                }
            },
            onCountryChange: function (countryCode) {
                // console.log('onCountryChange', countryCode);
                Object.assign(this.billing, this.billing, { country: countryCode, state_prov: '' });
            },
            onStateChange: function (state) {
                // console.log('onStateChange', state);
                Object.assign(this.billing, this.billing, { state_prov: state });
            },
            showTermsConditions: function () {
                Event.$emit('termsConditionsPopup');
            },
            shippingChanged: function (event) {
                var targetId = event.currentTarget.id;
                if (targetId == 'ship2another') {
                    // this.shipTo = targetId;
                    Event.$emit('showAnotherAddressPopup');
                } else if (targetId == 'ship2multiple') {
                    //this.shipTo = targetId;
                    Event.$emit('showMultipleAddressPopup');
                } else {
                    this.$store.commit('setShipToBilling');
                }
            },
            onAnotherAdressSubmitted: function (address) {
                this.$store.commit('setAnotherAddress', address);
            },
            onNewAdressSubmitted: function (address) {
                this.$store.commit('addNewAddress', address);
            },
            calcLineItemTotal: function (prodId, childId, qty) {
                var price = this.childProducts[prodId].children[childId].price;
                return Vue.filter('currency')(price * qty, {symbol: ''});
            },
            getCartItemImage: function (cartItem) {
                var itemId = cartItem.item_id;
                var product = this.products[itemId];
                var logosList = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in product && product.options) {
                        if ("logo" in product.options && product.options.logo) {
                            logosList = product.options.logo;
                        }
                    }
                }
                var res = '';
                var logoId = 'logo' in cartItem.options ? cartItem.options.logo : '';
                if (logoId in logosList) {
                    res = this.baseImagePath + logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + product.item_image_blank;
                return res;
            },
            submitCustomerOrder: function () {
                this.isPlacingOrder = true;
                this.$store.commit('updateBillingAddress', this.billing);
                this.$validator.validateAll().then(() => {
                    /* global FRS_CAMPAIGN, FRS_API_HOST */
                    var endpoint = window.location.protocol + FRS_API_HOST + '/api/order/invoice';
                    var payload = {
                        campaign: FRS_CAMPAIGN,
                        billing: this.billing,
                        payment: Object.assign({}, { amount: this.orderTotal }),
                        addresses: this.addresses,
                        ship_to: this.shipTo,
                        promo: this.promo,
                        marketing: this.marketing,
                        items: this.cart
                    };
                    switch (this.shipTo) {
                        case "ship2multiple" :
                            Object.assign(payload, {
                                ship_item_to: this.shipItemTo
                            });
                            break;
                    }
                    // debugger;
                    /**/
                    this.$http.post(endpoint, payload).then(function(response) {
                        var data = response.body || {};
                        var success = 'success' in data ? data.success : false;
                        if (success) {
                            this.$store.commit('completeTheInvoice', data);
                            this.$router.push({ path: '/payment'});
                        } else {
                            var error = 'error' in data ? data.error : '';
                            if (error.length > 0) {
                                console.log('error message:', error);
                                // TODO: rework with VeeValidate
                                var section = 'section' in data ? data.section : '';
                                if (section in this.errs) {
                                    this.errs[section] = error;
                                }
                            }
                        }
                        this.isPlacingOrder = false;
                    }, function (error) {
                        this.isPlacingOrder = false;
                        console.log('Network error: ', error);
                    });
                    /**/
                    // DEBUG
                    /** /
                    this.$store.commit('completeTheOrder', { order: 123 });
                    this.$router.push({ path: '/confirmation'});
                    /**/
                }).catch(function (err) {
                    // debugger;
                    this.isPlacingOrder = false;
                    console.log('Need to correct some errors first!');
                });
                return false;
            }
        },
        watch: {
            'fedex.isValidated': {
                handler: function (isValidated) {
                    const billing = this.billing;
                    if (!isValidated) {
                        Object.assign(billing, { 'total_tax_rate': 0.0 });
                    }
                    this.$store.commit('updateBillingAddress', billing);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Checkout.vue?cab69352